/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MultiBundleWalletInviteData } from '../../models/multi-bundle-wallet-invite-data';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetBundleWalletInviteData$Params {
  token: Token64LengthType;
}

export function externalGetBundleWalletInviteData(http: HttpClient, rootUrl: string, params: ExternalGetBundleWalletInviteData$Params, context?: HttpContext): Observable<StrictHttpResponse<MultiBundleWalletInviteData>> {
  const rb = new RequestBuilder(rootUrl, externalGetBundleWalletInviteData.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MultiBundleWalletInviteData>;
    })
  );
}

externalGetBundleWalletInviteData.PATH = '/external/bundle/wallet-invite';
